<template>
  <v-row
    class="pa-1 latestRelease"
    v-if="latest_release"
    :style="{ maxHeight: $vuetify.breakpoint.xs ? '200px' : '' }"
  >
    <v-col
      cols="3"
      sm="4"
      v-for="ost in latest_release"
      :key="ost.id"
      class="pa-1"
    >
      <v-img
        v-if="ost.photo"
        :src="ost.photo"
        @click="$router.push('/discography/1/project/' + ost.id)"
        class="pointer"
      ></v-img>
      <v-img
        v-else
        src="@/assets/LOGO_ALBUM.jpg"
        @click="$router.push('/discography/1/project/' + ost.id)"
        class="pointer"
      >
        <span
          class="pa-1 font-weight-normal mt-n1 mr-1 overline grey darken-4 mx-auto"
          style="position: relative; top: 5px; border-radius: 2px;"
        >
          {{ ost.title | truncate(27, " ") }}
        </span>
      </v-img>
    </v-col>
  </v-row>
</template>
<script>
import SendRequestMixin from "../../mixins/SendRequestMixin";

export default {
  name: "TheLatestRelease",
  mixins: [SendRequestMixin],
  data() {
    return {
      latest_release: []
    };
  },
  methods: {
    getData() {
      this.sendRequest({
        endpoint: "/latest_release",
        store_as: "latest_release",
        list: true
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="sass">
.latestRelease
	max-height: 30vh
	overflow-x: hidden
	overflow-y: overlay
</style>
